import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const ConditionalPortalWrapper = ({ children, container }) => {
	return container ? ReactDOM.createPortal(children, container) : children;
};

export default ConditionalPortalWrapper;

ConditionalPortalWrapper.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	// Note: container: PropTypes.instanceOf(Element) doesn't work with SSR (ReferenceError).
	// Solution: See "Note about server side rendering" in https://stackoverflow.com/a/51127130
	container: PropTypes.oneOfType([
		PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element), // For DOM elements
		PropTypes.oneOf([null]) // For null
	])
};
